export interface RecibossMod {
    id_Recibo: number;
    idCliente: string;
    cuenta: string;
    fechaEmision: any;
    monto: any;
    estado: string;
    CodigoQR: string;
    numeroTargeta: string;
    ccv: string;
    mesCC: number;
    añoCC: number;
    nombreTarjeta: string;
    apellidoTarjeta: string;
    deviceFingerPrintID: number;
   
      
}

export class RecibossMod implements RecibossMod {
    constructor(init?: RecibosFormValues) {
        Object.assign(this, init);
    }
}

export class RecibosFormValues {
    id_Recibo: number = 0
    idCliente: string = "";
    cuenta: string = "";
    fechaEmision: Date | null = null;
    monto: string = "";
    estado: string = "";
    CodigoQR: string = "";
    numeroTargeta: string = "";
    ccv: string = "";
    mesCC: number = 0;
    añoCC: number = 0;
    nombreTarjeta: string = "";
    apellidoTarjeta: string = "";  
    deviceFingerPrintID: number = 0;      
   
    
    constructor(RecibosMod?: RecibosFormValues) {
        if (RecibosMod) {
            this.id_Recibo = RecibosMod.id_Recibo;
            this.idCliente = RecibosMod.idCliente;
            this.cuenta = RecibosMod.cuenta;
            this.fechaEmision = RecibosMod.fechaEmision;  
            this.monto = RecibosMod.monto;
            this.CodigoQR = RecibosMod.CodigoQR;
            this.numeroTargeta = RecibosMod.numeroTargeta
            this.ccv = RecibosMod.ccv
            this.mesCC = RecibosMod.mesCC
            this.añoCC = RecibosMod.añoCC
            this.nombreTarjeta = RecibosMod.nombreTarjeta
            this.apellidoTarjeta = RecibosMod.apellidoTarjeta
            this.deviceFingerPrintID = RecibosMod.deviceFingerPrintID
            
           
            
        }

    }
}


